export default "__VITE_ASSET__WJQOWruk__"